<div class="modal-header">
  <h5 class="modal-title">
    <i class="fas fa-share-alt"></i> Add Rate Mapping
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <p>
    Please select a Tokeet rate category then a channel rate category to map.
    The selected Tokeet rate category will be pushed to the selected channel rate category during automatic and manual rate pushes.
  </p>

  <form [formGroup]="form" (submit)="onSubmit(form)">
    <div class="row">
      <div class="col-12">
        <app-select-search
          bindValue="id"
          bindLabel="name"
          [items]="categories"
          [ctrl]="form.get('category')"
          [multiple]="false"
          placeholder="Select a Tokeet rate category">
          <ng-container class="error-container">
            <mat-error>
              Category is <strong>required</strong>
            </mat-error>
          </ng-container>
        </app-select-search>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <app-select-search
          bindLabel="channelFriendlyName"
          [items]="connections"
          [ctrl]="form.get('connection')"
          [multiple]="false"
          placeholder="Select a channel">
          <ng-container class="error-container">
            <mat-error>
              Channel is <strong>required</strong>
            </mat-error>
          </ng-container>
        </app-select-search>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-room-rates">
        <app-select-search
          bindLabel="name"
          [items]="roomRates[selectedChannelId] || []"
          [ctrl]="form.get('roomRate')"
          [multiple]="false"
          placeholder="Select a channel rate category">
          <ng-container class="error-container">
            <mat-error>
              Channel rate category is <strong>required</strong>
            </mat-error>
          </ng-container>
        </app-select-search>

        <span *ngIf="loadingRoomRates[selectedChannelId]" class="fas fa-spinner fa-spin"></span>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase" tabindex="202">
    <i class="fal fa-times"></i> Cancel
  </button>
  <button (click)="onSubmit(form)" [disabled]="form.disabled" type="button" class="btn btn-success text-uppercase create-btn" tabindex="201">
    <i *ngIf="!form.disabled" class="fal fa-save"></i>
    <i *ngIf="form.disabled" class="fal fa-spinner fa-spin"></i>
    Save Mapping
  </button>
</div>
